import React from 'react'
import EditTableRow from '../Row'

export default function EditTable({
    rows,
    readOnly
}) {

    return (
        <div className='w-full overflow-x-auto'>
            <div className="table min-w-full border border-line rounded-lg">
                {rows?.map((row, index) => {
                    return (
                        <EditTableRow
                            row={row}
                            index={index}
                            key={`row-${index}`}
                            readOnly={readOnly}
                        />
                    )
                })} 
            </div>
        </div>
    )
}
